// reducer.js
import {
  FETCH_ROLES_REQUEST,

  FETCH_ROLES_SUCCESS,

  FETCH_ROLES_FAILURE,
} from './actions';

const initialState = {
  role_datas: null,
  loading: false,
  error: null,
};

const ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROLES_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ROLES_SUCCESS:
      return { ...state, loading: false, role_datas: action.payload, data: action.payload };

    case FETCH_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload };

      default:
      return state;
  }
};

export default ticketReducer;
